import React, { useState, useEffect } from 'react'
import useMediaQuery from '../hooks/mediaQuery'
import axios from 'axios'
import uuid from 'uuid/v4'

import ErrorComponent from '../Error'
import LoadingComponent from '../Loading'

import '../styles/fpren.css'
import '../styles/fpren_outlook.css'
import helpers from '../utils/helpers'

export default function Outlook({ userLocation }) {
  const [ outlook, setOutlook ] = useState([])
  const [ error, setError ] = useState(null)
  const [ isLoaded, setIsLoaded ] = useState(false)
  const isSmallMobileDevice = useMediaQuery('(max-width: 992px)')
  const [ lat, lon ] = userLocation

  useEffect(() => {

    axios.get(`https://pbsweather.org/shared/server/udfd.php?lat=${lat}&lon=${lon}&days=7`)
      .then(
        res => {
          setIsLoaded(true)
          const data = res.data.udfd_basic.data
          let udfd = []
          data.forEach(day => {
            udfd.push({
              id: uuid(),
              dayLong: helpers.convertToDayOfWeek(day.daytime ? day.daytime.valid_begin : 'N/A').long,
              dayShort: helpers.convertToDayOfWeek(day.daytime ? day.daytime.valid_begin : 'N/A').short,
              weatherCode: helpers.getMetarIcon(
                day.daytime ? day.daytime.weather_code.value : 'N/A', 
                true
              ),
              weather: day.daytime ? day.daytime.weather_code.text : 'N/A',
              min: helpers.convertTemperature(day.temperature ? day.temperature.min : 'N/A').fahrenheit,
              max: helpers.convertTemperature(day.temperature ? day.temperature.max : 'N/A').fahrenheit,
              pop: day.daytime ? day.daytime.precipitation.probability.value : 'N/A'
            })
          })
          setOutlook(udfd)
        },
        error => {
          setIsLoaded(true)
          setError(error)
        }
      )

  }, [ lat, lon ])

  if (error) return <ErrorComponent />
  if (!isLoaded) return <LoadingComponent />

  return (
    <div className='panel-wrap panel-wrap-outlook-padding' id='7day-wrap'>
      {outlook.map(day => {
        return (
          <div key={day.id} className='panel daily'>
              { isSmallMobileDevice ? <p className='daylabel day'>{day.dayShort}</p> : <p className='daylabel day'>{day.dayLong}</p> }
              <img className='dayicon day' src={day.weatherCode} alt='Weather Icon'></img>
              <p className='dayphrase day'>{day.weather}</p>
              <p className='daylow day'>{day.min}&deg;</p>
              <p className='dayhigh day'>{day.max}&deg;</p>
              <p className='daypop day'>{day.pop}%</p>
          </div>
        )
      })}
    </div>
  )

}